module.exports = __webpack_public_path__ + "static/media/dinner1-1.456af469.jpg";